import { asMarkdownTemplate } from '../../../webmodule-common/other/general/markdown';
import { getCurrentUser } from '../../../webmodule-common/other/api/current-user';
import { html, TemplateResult } from 'lit';
import { information } from '../../../webmodule-common/other/ui/modal-option';
import { isEmptyOrSpace } from '../../../webmodule-common/other/ui/string-helper-functions';
import { LitBaseModal } from '../../../webmodule-common/other/ui/modal/modal-factory-lit';
import { tlang } from '../../../webmodule-common/other/language/lang';

export enum QuoteTechnicalReviewQuery {}
export class QuoteTechnicalReviewDialog extends LitBaseModal {
  poNumberRequired = false;
  forceIssueOrder = false;
  supplierName: string;
  orderNumber = '';
  allowSupplierToIssue = false;
  ok = false;
  constructor(poNumberRequired: boolean, forceIssueOrder: boolean, supplierName: string, orderNumber: string) {
    super();
    this.poNumberRequired = poNumberRequired;
    this.forceIssueOrder = forceIssueOrder;
    this.supplierName = supplierName;
    this.orderNumber = orderNumber;
  }

  private async validateNumber() {
    if (this.poNumberRequired && isEmptyOrSpace(this.orderNumber)) {
      const user = getCurrentUser();
      const dealerName = (user as any).tenantName ?? tlang`%%franchisee%%`;

      await information(tlang`${dealerName} Order No is required`);
      return false;
    }
    return true;
  }
  private yesEvent = async () => {
    if (!(await this.validateNumber())) {
      return;
    }
    this.allowSupplierToIssue = true;
    this.ok = true;
    this.hideModal();
  };
  private noEvent = async () => {
    if (!(await this.validateNumber())) {
      return;
    }
    this.ok = true;
    this.hideModal();
  };
  private cancelEvent = async () => {
    this.ok = false;
    this.hideModal();
  };

  async canClose() {
    return true;
  }
  footerTemplate(): TemplateResult | null | undefined {
    return this.forceIssueOrder
      ? html` <webmodule-button variant="default" @click=${this.cancelEvent}>${tlang`Cancel`} </webmodule-button>
          <webmodule-button variant="primary" @click=${this.yesEvent}>${tlang`Send`}</webmodule-button>`
      : html` <webmodule-button variant="default" @click=${this.cancelEvent}>${tlang`Cancel`} </webmodule-button>
          <webmodule-button variant="default" @click=${this.noEvent}>${tlang`No thanks`} </webmodule-button>
          <webmodule-button variant="primary" @click=${this.yesEvent}>${tlang`Yes`}</webmodule-button>`;
  }
  get isFooterVisible(): boolean {
    return true;
  }
  private eventPO = (e: Event) => {
    this.orderNumber = (e.currentTarget as HTMLInputElement).value;
  };

  title(): string | TemplateResult {
    return tlang`Technical Review`;
  }
  bodyTemplate(): TemplateResult {
    const user = getCurrentUser();
    const mandatory = this.poNumberRequired ? html`<span class="text-danger "><sup>*</sup></span>` : html``;
    const dealerName = (user as any).tenantName ?? tlang`%%franchisee%%`;
    const verbage = this.forceIssueOrder
      ? tlang`${'ref:technical-review-direct-to-supplier'}
            This %%quote%% will now be submitted to **${this.supplierName}** for a 
            %%technical-review%%.

            *If approved without changes, the %%purchase-order-abrev%% will be dispatched to* **${this.supplierName}**

            `
      : tlang`${'ref:technical-review-with-approval'}
            This %%quote%% will now be submitted to **${this.supplierName}** for a 
            %%technical-review%%.

            If approved without changes, would you like **${this.supplierName}** to !!purchase-order-state-issued!! the %%purchase-order-abrev%% on your behalf? If not, a !!purchase-order-state-draft!! 
            %%purchase-order-abrev%% will be generated for you to !!purchase-order-state-issued!!.
`;
    return html`<div class="me-2">${asMarkdownTemplate(verbage, true)}</div>
      <div>
        <label>${dealerName} Order No: ${mandatory}</label
        ><input
          id="ponumber"
          type="text"
          maxlength="200"
          .value=${this.orderNumber}
          @changed=${this.eventPO}
          @blur=${this.eventPO}
        />
      </div>`;
  }
}
